import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop';
import ShippersLanding from './components/shippers/ShippersLanding';
import ArticlePage from './components/stories/ArticlePage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<ShippersLanding />} />
        <Route path="/stories/:slug" element={<ArticlePage />} />
      </Routes>
    </>
  );
}
